import React from "react";
import { InstagramIcon, TikTokIcon } from "./icons/BrandIcons";
import { links } from "../data/content";
export function Footer() {
  return <footer className="border-t border-ink-3 px-6 py-10" data-id="element-39" data-mp="3ggk90wy2pg0l">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-5 text-center text-xs text-muted md:flex-row md:justify-between md:text-left" data-id="element-40" data-mp="32onjn0nshk7w">
        <div data-id="element-41" data-mp="36nd6rkymqg4q">
          <p className="font-serif text-base font-bold text-gold" data-id="element-42" data-mp="3uf0opddwyguv">Marcos Rosell</p>
          <p data-id="element-43" data-mp="3ucxmzw3eezab">Papá · Motero · Marketing Digital</p>
        </div>
        <div className="flex items-center gap-6" data-id="element-44" data-mp="37ft3219eq1n">
          <a href={links.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[13px] text-gold transition-colors duration-150 hover:text-gold-light" data-id="element-45" data-mp="3lecbgkwcgkj1">
            <InstagramIcon className="h-[18px] w-[18px]" data-id="element-46" data-mp="29ydwy1ied6af" />
            @marketingconmarcos
          </a>
          <a href={links.tiktok} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[13px] text-gold transition-colors duration-150 hover:text-gold-light" data-id="element-47" data-mp="2ez1nyn6mln4n">
            <TikTokIcon className="h-4 w-4" data-id="element-48" data-mp="3v7q6hr3xkngk" />
            @mkt_con_marcos
          </a>
        </div>
        <p data-id="element-49" data-mp="3q8n2m9zosna6">© 2026 Marketing con Marcos · Todos los derechos reservados</p>
      </div>
    </footer>;
}